import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import MatchesThisWeek from '@/pages/MatchesThisWeek'
import SportsPage from '@/pages/sport/Sports'
import SportPage from '@/pages/sport/Sport'
import FederationsPage from '@/pages/federation/Federations'
import FederationPage from '@/pages/federation/Federation'
import ClubsPage from '@/pages/ClubsPage'
import TeamsPage from '@/pages/TeamsPage'
import MatchesPage from '@/pages/MatchesPage'
import PlacesPage from '@/pages/Places'
import RegionsPage from '@/pages/Regions'
import RegionDetail from '@/pages/RegionDetail'
import CompetitionsPage from '@/pages/CompetitionsPage'
import EditCompetition from '@/pages/EditCompetition'
import VideosPage from '@/pages/VideosPage'
import UsersPage from '@/pages/Users'
import NotificationsPage from '@/pages/Notifications'
import TopActionsPage from '@/pages/TopActions'
import ClipsPage from '@/pages/ClipsPage'
import LoginPage from '@/pages/Login'
import NotFound from '@/pages/NotFound'
import store from '../store'
import Amplify from 'aws-amplify'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/dev',
      beforeEnter () {
        window.location.href = 'http://dev-back-office.rematch.tv'
      }
    },
    {
      path: '/preprod',
      beforeEnter () {
        window.location.href = 'http://preprod-back-office.rematch.tv'
      }
    },
    {
      path: '/prod',
      beforeEnter () {
        window.location.href = 'http://back-office.rematch.tv'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/matchesthisweek',
      name: 'MatchesThisWeek',
      component: MatchesThisWeek
    },
    {
      path: '/sports',
      name: 'Sports',
      component: SportsPage
    },
    {
      path: '/sports/:id',
      name: 'Sport',
      component: SportPage
    },
    {
      path: '/federations',
      name: 'Federations',
      component: FederationsPage
    },
    {
      path: '/federations/:id',
      name: 'Federation',
      component: FederationPage
    },
    {
      path: '/regions',
      name: 'Regions',
      component: RegionsPage
    },
    {
      path: '/regions/:id',
      name: 'RegionDetail',
      component: RegionDetail
    },
    // {
    //   path: '/categories',
    //   name: 'Categories',
    //   component: CategoriesPage
    // },
    {
      path: '/competitions',
      name: 'Competitions',
      component: CompetitionsPage
    },
    {
      path: '/competitions/:id',
      name: 'EditCompetition',
      component: EditCompetition
    },
    {
      path: '/places',
      name: 'Places',
      component: PlacesPage
    },
    {
      path: '/clubs',
      name: 'Clubs',
      component: ClubsPage
    },
    {
      path: '/teams',
      name: 'Teams',
      component: TeamsPage
    },
    {
      path: '/matches',
      name: 'Matches',
      component: MatchesPage
    },
    {
      path: '/videos',
      name: 'Videos',
      component: VideosPage
    },
    {
      path: '/users',
      name: 'Users',
      component: UsersPage
    },
    {
      path: '/notifications',
      name: 'Notifications',
      component: NotificationsPage
    },
    {
      path: '/topactions',
      name: 'TopActions',
      component: TopActionsPage
    },
    {
      path: '/clips',
      name: 'Clips',
      component: ClipsPage
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/not-found'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const cb = () => {
    if (store.state.connected) {
      next(to.path === '/login' ? '/' : undefined)
    } else {
      next(to.path !== '/login' ? '/login' : undefined)
    }
  }

  if (!store.state.connected) {
    Amplify.Auth.currentSession()
      .then(session => {
        store.commit('SET_CONNECTED', session.idToken.jwtToken)
      })
      .finally(cb)
  } else {
    cb()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js